import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { TournamentsComponent } from './pages/tournaments/tournaments.component';
import { AuthGuard } from './helpers/auth.guard';
import { CentersComponent } from './pages/centers/centers.component';
import { CenterDetailComponent } from './pages/center-detail/center-detail.component';
import { FrameComponent } from './pages/frame/frame.component';
import { TournamentDetailGroupsComponent } from './pages/tournament-detail/tournament-detail-groups/tournament-detail-groups.component';
import { TournamentDetailStandingComponent } from './pages/tournament-detail/tournament-detail-standing/tournament-detail-standing.component';
import { TournamentDetailPlayoffsComponent } from './pages/tournament-detail/tournament-detail-playoffs/tournament-detail-playoffs.component';
import { TournamentDetailTeamsComponent } from './pages/tournament-detail/tournament-detail-teams/tournament-detail-teams.component';
import { TournamentNewComponent } from './pages/tournament-new/tournament-new.component';
import { TournamentsActiveComponent } from './pages/tournaments/tournaments-active/tournaments-active.component';
import { TournamentsFinishedComponent } from './pages/tournaments/tournaments-finished/tournaments-finished.component';
import { tournamentDetailResolver } from './resolvers/tournament-detail.resolver';
import { TournamentDetailRoundsComponent } from './pages/tournament-detail/tournament-detail-rounds/tournament-detail-rounds.component';
import { PublicStandingsComponent } from './pages/public/public-standings/public-standings.component';
import { PublicGroupsComponent } from './pages/public/public-groups/public-groups.component';
import { PublicRoundsComponent } from './pages/public/public-rounds/public-rounds.component';
import { PublicWpTestingComponent } from './pages/public-wp-testing/public-wp-testing.component';
import { DevOnlyGuard } from './helpers/dev-only.guard';
import { UserAdminComponent } from './pages/user-admin/user-admin.component';
import { TournamentDetailComponent } from './pages/tournament-detail/tournament-detail.component';
import { RoleGuard } from './helpers/role.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'public',
    children: [
      {
        path: 'standings/:id',
        component: PublicStandingsComponent
      },
      {
        path: 'groups/:id',
        component: PublicGroupsComponent
      },
      {
        path: 'rounds/:id',
        component: PublicRoundsComponent
      }

    ]
  },
  {
    path: 'admin',
    component: FrameComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'centers',
        component: CentersComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['admin', 'staff'] }
      },
      {
        path: 'centers/center-detail',
        component: CenterDetailComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['admin', 'staff'] }
      },
      {
        path: 'centers/center-detail/:id',
        component: CenterDetailComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['admin', 'staff'] }
      },
      {
        path: 'tournaments',
        component: TournamentsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'active',
            component: TournamentsActiveComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'finished',
            component: TournamentsFinishedComponent,
            canActivate: [AuthGuard]
          },
        ]
      },
      {
        path: 'tournaments/new',
        component: TournamentNewComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'tournaments/new/:id', // edit tournament main data
        component: TournamentNewComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'tournaments/:id',
        component: TournamentDetailComponent,
        canActivate: [AuthGuard],
        resolve: {
          tournamentLoaded: tournamentDetailResolver
        },
        children: [
          {
            path: 'teams',
            component: TournamentDetailTeamsComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'groups',
            component: TournamentDetailGroupsComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'standing',
            component: TournamentDetailStandingComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'rounds', // necessary because :roundId is optional
            component: TournamentDetailRoundsComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'rounds/:roundId',
            component: TournamentDetailRoundsComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'playoffs',
            component: TournamentDetailPlayoffsComponent,
            canActivate: [AuthGuard]
          },
        ]
      },
      {
        path: 'users',
        component: UserAdminComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['admin'] }
      }
    ]
  },
  {
    path: 'public-dev-wp',
    component: PublicWpTestingComponent,
    canActivate: [DevOnlyGuard]
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
];
